import {
  ADDRESS_ERROR,
  ADDRESS_LOADING,
  ADDRESS_SUCCESS,
  AMOUNT_OWED_ERROR,
  AMOUNT_OWED_LOADING,
  AMOUNT_OWED_SUCCESS,
  CLAIMED_DEPENDENTS_ERROR,
  CLAIMED_DEPENDENTS_LOADING,
  CLAIMED_DEPENDENTS_SUCCESS,
  COMPLIANCE_STATUS_ERROR,
  COMPLIANCE_STATUS_LOADING,
  COMPLIANCE_STATUS_SUCCESS,
  DELETE_AMOUNT_SUCCESS,
  EDIT_AMOUNT_OWED_SUCCESS,
  LEVY_SUCCESS,
  MARITAL_STATUS_ERROR,
  MARITAL_STATUS_LOADING,
  MARITAL_STATUS_SUCCESS,
  NEW_AMOUNT_OWED_SUCCESS,
  PROFILE_ERROR,
  PROFILE_LOADING,
  PROFILE_SUCCESS,
  SET_AMOUNT_OWED_YEARS,
  COUNTIES_SUCCESS,
  POWER_OF_ATTORNEY_SUCCESS,
  POWER_OF_ATTORNEY_ERROR,
} from '@/app/personal/store/types';

export const mutations = {
  [PROFILE_LOADING]: (state) => {
    state.profileLoadingStatus = 'loading';
  },
  [PROFILE_SUCCESS]: (state, profile) => {
    state.profileLoadingStatus = 'success';
    state.profile = profile;
  },
  [PROFILE_ERROR]: (state) => {
    state.profileLoadingStatus = 'error';
  },
  [MARITAL_STATUS_LOADING]: (state) => {
    state.maritalStatusLoadingStatus = 'loading';
  },
  [MARITAL_STATUS_SUCCESS]: (state, maritalStatusData) => {
    state.maritalStatusLoadingStatus = 'success';
    state.maritalStatus = maritalStatusData;
  },
  [MARITAL_STATUS_ERROR]: (state) => {
    state.maritalStatusLoadingStatus = 'error';
  },
  [ADDRESS_LOADING]: (state) => {
    state.addressLoadingStatus = 'loading';
  },
  [ADDRESS_SUCCESS]: (state, addressData) => {
    state.addressLoadingStatus = 'success';
    state.address = addressData;
  },
  [ADDRESS_ERROR]: (state) => {
    state.addressLoadingStatus = 'error';
  },
  [COMPLIANCE_STATUS_LOADING]: (state) => {
    state.complianceStatusLoadingStatus = 'loading';
  },
  [COMPLIANCE_STATUS_SUCCESS]: (state, complianceStatusData) => {
    state.complianceStatusLoadingStatus = 'success';
    state.complianceStatus = complianceStatusData;
  },
  [COMPLIANCE_STATUS_ERROR]: (state) => {
    state.complianceStatusLoadingStatus = 'error';
  },
  [AMOUNT_OWED_LOADING]: (state) => {
    state.amountOwedLoadingStatus = 'loading';
  },
  [AMOUNT_OWED_SUCCESS]: (state, amountOwedItems) => {
    state.amountOwedLoadingStatus = 'success';
    state.amountOwedItems = amountOwedItems;
  },
  [AMOUNT_OWED_ERROR]: (state) => {
    state.amountOwedLoadingStatus = 'error';
  },
  [LEVY_SUCCESS]: (state, levyData) => {
    state.amountOwedLoadingStatus = 'success';
    state.levy = levyData;
  },
  [NEW_AMOUNT_OWED_SUCCESS]: (state, resp) => {
    state.amountOwedLoadingStatus = 'success';
    const newItem = JSON.parse(resp.config.data);
    newItem.id = resp.data.id;
    state.amountOwedItems.push(newItem);
  },
  [DELETE_AMOUNT_SUCCESS]: (state, id) => {
    state.amountOwedLoadingStatus = 'success';
    const index = state.amountOwedItems.findIndex(amountOwedItem => amountOwedItem.id === id);
    state.amountOwedItems.splice(index, 1);
  },
  [EDIT_AMOUNT_OWED_SUCCESS]: (state, item) => {
    state.amountOwedLoadingStatus = 'success';
    const index = state.amountOwedItems
      .findIndex(amountOwedItem => amountOwedItem.id === item.editedItemId);
    state.amountOwedItems.splice(index, 1, item.newItem);
  },
  [CLAIMED_DEPENDENTS_LOADING]: (state) => {
    state.claimedDependentsLoadingStatus = 'loading';
  },
  [CLAIMED_DEPENDENTS_SUCCESS]: (state, resp) => {
    state.claimedDependentsLoadingStatus = 'success';
    state.claimedDependents = resp;
  },
  [CLAIMED_DEPENDENTS_ERROR]: (state) => {
    state.claimedDependentsLoadingStatus = 'error';
  },
  [SET_AMOUNT_OWED_YEARS]: (state, years) => {
    state.amountOwedYears = years;
  },
  [COUNTIES_SUCCESS]: (state, resp) => {
    state.addressLoadingStatus = 'success';
    state.countiesOfState = [];
    resp.forEach(item => state.countiesOfState.push(item));
  },
  [POWER_OF_ATTORNEY_SUCCESS]: (state) => {
    state.amountOwedLoadingStatus = 'success';
  },
  [POWER_OF_ATTORNEY_ERROR]: (state) => {
    state.amountOwedLoadingStatus = 'error';
  },
};
